import React from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";

const ShareSuccessModal = ({
  isOpen,
  onClose,
  goBackHandler,
  data,
  selectedMembers,
}) => {
  return (
    <CommonModal title={""} onClose={goBackHandler} isOpen={isOpen} showAlert={false}>
      <div className="text-lg font-medium text-center mb-0">
        {data?.assistant_name} has been shared with the following:
      </div>
      <div className="text-sm text-center mt-2.5 mb-10">
        You can edit who has access to this Agent at any time.{" "}
      </div>

      {/* Select specific members */}
      <div className="border !border-border rounded-[5px] p-6">
        <div className="max-h-56 overflow-y-auto flex flex-col gap-3 pr-2">
          {selectedMembers.map((member) => (
            <div
              key={member.id}
              className="flex items-center justify-between border !border-border rounded-[5px] p-4 bg-card"
            >
              <span className="text-sm text-foreground">{member.name}</span>
            </div>
          ))}
        </div>
      </div>
      <button
        className="mt-5 w-full bg-primary text-primary-foreground rounded-[3px] py-4 text-sm font-medium"
        onClick={() => {
          // handle share logic here
          goBackHandler();
        }}
      >
        Done
      </button>
      <button
        className="mt-5 w-full text-foreground text-sm font-medium"
        onClick={() => {
          onClose();
        }}
      >
        Go Back
      </button>
    </CommonModal>
  );
};

export default ShareSuccessModal;
